export var MessageStyle = /*#__PURE__*/function (MessageStyle) {
  MessageStyle["SPECIAL"] = "SPECIAL";
  MessageStyle["STATUS"] = "STATUS";
  MessageStyle["SCIENCE"] = "SCIENCE";
  MessageStyle["QUESTION"] = "QUESTION";
  MessageStyle["ACCOUNT"] = "ACCOUNT";
  MessageStyle["SERIOUS"] = "SERIOUS";
  return MessageStyle;
}(MessageStyle || {});
export var MessageFeedback = /*#__PURE__*/function (MessageFeedback) {
  MessageFeedback[MessageFeedback["SKIP"] = 1] = "SKIP";
  MessageFeedback[MessageFeedback["LIKE"] = 2] = "LIKE";
  MessageFeedback[MessageFeedback["DISLIKE"] = 3] = "DISLIKE";
  MessageFeedback[MessageFeedback["SHRUG"] = 4] = "SHRUG";
  return MessageFeedback;
}(MessageFeedback || {});
export var MessageDislikeReason = /*#__PURE__*/function (MessageDislikeReason) {
  MessageDislikeReason[MessageDislikeReason["NOTHING"] = 1] = "NOTHING";
  MessageDislikeReason[MessageDislikeReason["TIMING"] = 2] = "TIMING";
  MessageDislikeReason[MessageDislikeReason["REPETITIVE"] = 3] = "REPETITIVE";
  MessageDislikeReason[MessageDislikeReason["TONE"] = 4] = "TONE";
  MessageDislikeReason[MessageDislikeReason["CONTENT"] = 5] = "CONTENT";
  MessageDislikeReason[MessageDislikeReason["STOP_SENDING"] = 6] = "STOP_SENDING";
  MessageDislikeReason[MessageDislikeReason["OTHER"] = 7] = "OTHER";
  return MessageDislikeReason;
}(MessageDislikeReason || {});
export var MediaType = /*#__PURE__*/function (MediaType) {
  MediaType["IMAGE"] = "IMAGE";
  MediaType["ICON"] = "ICON";
  MediaType["VIDEO"] = "VIDEO";
  return MediaType;
}(MediaType || {});
export var ButtonCategory = /*#__PURE__*/function (ButtonCategory) {
  ButtonCategory["PRIMARY"] = "PRIMARY";
  ButtonCategory["SECONDARY"] = "SECONDARY";
  // ...
  return ButtonCategory;
}(ButtonCategory || {});